<template>
 
    <div   >
         <!-- class="function_wrap"  -->
        <!-- <div id='head_tip' class="_tip"> 
            <span>【{{$store.state.companyInfo.company}} | {{$store.state.userInfo.depart? $store.state.userInfo.depart.depart:''}}】  欢迎， {{$store.state.userInfo.name? $store.state.userInfo.name :'' }}   </span>    
        </div> -->

        <!-- <div class="fun_row_bar">
            <el-menu   @select="handleSelectProcess" text-color="#000000"  :default-active="activeIndex"  mode="horizontal"   style="height:100%;border-bottom:none;">
                <el-menu-item    index="0"    style="height:100%;text-decoration:none;line-height: 40px"> 控制台 </el-menu-item>
            
                <el-submenu index="1" > 
                    <template slot="title" > 业务流程 </template>
                        <el-menu-item index="1001"   > 
                       
                        <div  class="head_title"> 客户登记 </div>
                    </el-menu-item>
 
                    <el-menu-item index="1002" > 
                        <div class="title" style="cursor:pointer">收案审批 </div>
                    </el-menu-item>
                    <el-menu-item index="1003" >  
                       
                        <div class="title">用印（或事项）申请 </div>
                    </el-menu-item>
                    <el-menu-item index="1004" > 
                        <div class="title">开票申请 </div>
                    </el-menu-item>
                    <el-menu-item index="1005" > 
                        <div class="title">退款申请 </div>

                    </el-menu-item>

                    <el-menu-item index="close_case" > 
                        <div class="title">结案归档申请 </div>
                    </el-menu-item>

                </el-submenu>

                <el-submenu index="service">
                    <template slot="title" > 行政办公 </template>
                        <el-menu-item index="mail"  > 
                        <div  class="head_title"> 寄件申请 </div>
                    </el-menu-item>

                        <el-menu-item index="takeoff" > 
                        <div class="title" style="cursor:pointer">请假申请</div>
                    </el-menu-item>

                </el-submenu>

                <el-submenu index="tools">
                    <template slot="title" > 工具 </template>
                    <el-menu-item index="self_notice"  > 
                        <div  class="head_title"> 设置事项到期提醒</div>
                    </el-menu-item>

              
                </el-submenu>

      

                <el-menu-item    index="2"    style="height:100%;text-decoration:none;line-height: 40px"> 信息管理 </el-menu-item>

                <el-menu-item  index="3"   style="height:100%;cursor:pointer;line-height: 40px "   > 通讯录 </el-menu-item>

                <el-menu-item  index="case"   style="height:100%;cursor:pointer;line-height: 40px "   >  案件管理 </el-menu-item>


     
            </el-menu>

        </div> -->


        <!-- <router-view  ></router-view> -->
    
                
        <div class="bench_wrap"> 
         


            <div class="left">
                <el-card    shadow="always" :style="'min-height:'+screenHeight+'px; ' ">
                    <div slot="header" class="clearfix">
                        <span >事项跟踪</span>

                       
                        <el-button style="float: right; padding: 3px 0;" type="text" @click="Check_More_Info"> 查看更多 </el-button>

                        <i style="float: right; margin-right:20px;font-size:22px" type="text" :class="flow_icon" @click="Refresh_Flow"></i>

             
                        
                    </div>
 
 
                    <!-- <div v-for="(o,index) in flow" :key="o._id"  :class="$store.state.userInfo.userId==o.applier.userid? o.isread==0? 'item_follow':'item_follow2'  :   o.receiver.isread? 'item_follow2' :'item_follow'  "   -->
                    <div v-for="(o,index) in flow" :key="o._id"  :class="$store.state.userInfo.userId!=o.applier.userid && o.receiver ?   o.receiver.isread? 'item_follow2' :'item_follow' :  o.isread==0? 'item_follow':'item_follow2'   "      
                        @click="CheckThisFlow(o,index)" >

                        <div style="width:50%;overflow:hidden"> 
                            {{"【"+ o.log[o.log.length-1].who+"】 【"+ o.log[o.log.length-1].op+"】了"+o.sheetname  }} 
                            <!-- {{ o.log[o.log.length-1].status?  '。意见：【'+ o.log[o.log.length-1].status_ch+'】' :''   }} -->
                            
                        </div>
                        <!-- border:1px solid rgb(199, 231, 19); -->
                        <div class="right_part"  >
                            <!-- <span>与原件</span> -->
                            <span style="margin-right:10px;width:100px;text-align:center"> {{o.log[o.log.length-1].status_ch}} </span> 
                            <!-- <span style="margin-right:10px"> {{ o.isclose? '已完结':"未完结"  }}  </span>  -->

                            <el-tag  v-if="o.isclose" type="info" size='mini' style="margin-right:10px">已完结</el-tag>
                            <el-tag  v-else type="success" size='mini' style="margin-right:10px">未完结</el-tag>

                            <span  >{{o.log[o.log.length-1].date_time}}</span>
                        </div>

                    </div>

                </el-card>

            </div>
            <div class="mid">

                <div class="up"  :style="'height:'+screenHeight*0.5+'px;' " >
                    <el-card    shadow="always" :style="'height:'+screenHeight*0.5+'px; ' "  >
                        
                        <div slot="header" class="clearfix">
                            <span>消息与通知</span>
                            <el-button style="float: right; padding: 3px 0;" type="text" @click="openNoticePanel"> 查看更多 </el-button>
                            <!-- @click="Check_More_notice" -->
                            <!-- <el-button style="float: right; padding: 3px 0" type="text">操作按钮</el-button> -->
                        </div>

                          
 
                        <div     v-for="(o,index ) in notice" :key="o._id"  :class="o.isread=='no'? 'item_follow':'item_follow2' "      @click="open_notice_detail(o.content,o._id,index)" >
                                 <!-- @click="CheckThisNotice(o)" -->
                            <div style="width:60%"> 
                                {{ o.content }} 
                                <!-- {{ o.log[o.log.length-1].status?  '。意见：【'+ o.log[o.log.length-1].status_ch+'】' :''   }} -->
                                
                            </div>
                            <!-- border:1px solid rgb(199, 231, 19); -->
                            <div style="width:40%;display:flex;flex-direction:row;justify-content:flex-end">
                                <!-- <span style="margin-right:10px"> {{o.log[o.log.length-1].status_ch}} </span>  -->
                                <!-- <el-tag  v-if="o.isclose" type="info" style="margin-right:10px">已完结</el-tag>
                                <el-tag  v-else type="success" style="margin-right:10px">未完结</el-tag> -->

                                <span  >{{timestampToTime(o.timestamp/1000)}}</span>
                            </div>

                        </div>
       

                    </el-card>

                </div>
                <div class="down" >
                    <el-card    shadow="always"  :style="'height:'+screenHeight*0.5+'px; ' " >


                        <div slot="header" class="clearfix">
                            <span> 事项到期查看 （超期30日的不显示）</span>
                        </div>

                         
                     
                        <div     v-for="(o,index ) in self_notice.slice(0,10)" :key="o._id" class="item_follow" @click="CheckThisFlow(o,index)"  >
 
                                <div style="width:60%" > 
                                    <span v-if="o.template_id=='self_notice'">  {{ o.form.affair_name }}    </span>
                                   <span v-else-if="o.template_id=='1002'">    {{ o.form.case_name }} </span>
                                
                                </div>

        
                       
                                <div style="width:40%;display:flex;flex-direction:row;justify-content:flex-end">
                                    <el-badge v-if="o.form.endDate>timestamp "  :value="o.form.endDate-timestamp<days7?'<7天':
                            o.form.endDate-timestamp>days7 && o.form.endDate-timestamp<days30?'<30天':''    "  style="position:relative;margin-top:10px; margin-right: 40px;">  
                                    <span  >{{timestampToTime(o.form.endDate/1000)}}</span>
                                    </el-badge> 

                                    <el-badge v-else-if="o.form.endDate<timestamp "  value="已到期"  style="position:relative;margin-top:10px; margin-right: 40px;"> 
                                        <span  >{{timestampToTime(o.form.endDate/1000)}}</span>
                                    
                                    </el-badge> 


                                </div>

                        </div>

                       

                    </el-card>

                </div>


            </div>

            <div class="right">

                  <el-card    shadow="always" :style="'min-height:'+screenHeight+'px'">
                    <div slot="header" class="clearfix">
                        <span>我的工作</span>
                         
                        <el-button style="float: right; padding: 3px 0" type="text"> 总数：{{task_num}}</el-button>

                        <i style="float: right; margin-right:20px;font-size:22px" type="text" :class="apply_icon" @click="Refresh_myWork"></i>
                        <!-- <el-button  style="float: right; padding: 3px 0" type="text">查看更多</el-button> -->
                    </div>

                    <div class="mywork"  v-for="(item,index) of  apply.slice((apply_page-1)*10, (apply_page-1)*10+10  )"  v-bind:key="item._id">
                        <div class="up" :data-ind="index" :data-template_id="item.template_id"    :data-_id="item._id"  :data-mystatus="item.mystatus" @click="Turn2Detail">
                            您有一份来自【{{item.applier.realname}}】的【{{item.sheetname}}】待审核
                        </div>
                        <div class="down"> 
                            <div style="font-size:14px;margin-right:20px">{{timestampToTime(item.createtime) }}</div>
                            <!-- <el-tag v-if="item.mystatus==1" effect="plain">已完成</el-tag> -->
                            <el-tag  effect="plain">未完成</el-tag>
                        </div>
                    </div>


                    <div  class="page_box">
                        <!-- <Pages style="margin-top:30px;  float:right" :pageTotal="apply.length" :pageSize="10" @ChangePage="ChagenApplyPage"></Pages> -->

                        <el-pagination
                            v-if="apply.length>0"
                            style="margin-top:30px;  float:right;margin-right:40px"
                            :pager-count="5"
                            layout="prev, pager, next"
                            :total="apply.length"
                            @current-change="ChagenApplyPage">
                        </el-pagination>


                    </div>

                    <!-- <div v-for="o in 4" :key="o" class="text item ">
                        <div class="left">   {{'列表内容 ' + o }} </div>
                        <div class="right">     
                            <div class="date"> 2020-08-30</div>
                          
                            <div style="margin-left:10px;"> 通知 </div>
                            <div style="margin-left:10px;"> 已完成 </div>

                        </div>
                       
                    </div> -->

                </el-card>


            </div>


        </div>







        <el-dialog
            title="【消息中心】"
            :visible.sync="msgDialogVisible"
            top="10vh"
            >

            <div class='msgCenter'>
 


                <div  v-for="(item ,index) of  msgData"   v-bind:key="item._id"   > 

                    <div :class='index%2==0? "list_detail":"list_detail2"' style='width:100%;' :data-guest_id='item.guest_id'   :data-ind='index'  :data-nickname="item.nickName"   bindtap='bindtodetail' >
                    
                 
                        <div class="detail_n"   :data-guest_id='item.guest_id'  style="width:35px">{{index+1}}</div>

                        <div class="detail_n"     :data-guest_id='item.guest_id'  style="width:70px;position:relative;">
                 
                            <img :src="item.avatarUrl" alt="">
                            <!-- <mp-badge  v-if="item[userId].unread>0"  content="{{item[userId].unread>9? '9+':item[userId].unread }}" style="position: absolute;top: -.4em;right: -.3em;"/> -->
                        </div>

                        <div class="detail_n"     style="width:180px">{{item.nickName}}  </div>
                 
                        <div class="detail_n"  :data-name="item.name"    style="width:120px">
                        <pre>{{ item.lasttime }}</pre>
                        </div>
           
                        <div class="detail_n"  :data-name="item.name"  :data-id='item._id' style="width:70px"> 
                            <el-button type="info" plain :data-_id="item._id"   :data-ind="index"  style="height:24px;line-height:0px;">操作</el-button>
                        </div>  
                        
                    </div>
                
                </div>  


            </div>

            <!-- <span> 消息中心 </span> -->
            <span slot="footer" class="dialog-footer">
                <el-button @click="msgDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="msgDialogVisible = false">确 定</el-button>
            </span>
        </el-dialog>




        <el-dialog
            title="【通知中心】"
            :visible.sync="noticeDialogVisible"
            top="10vh"
            >

            <div class='msgCenter'>

                <div  v-for="(item ,index) of notice "   v-bind:key="index"   > 
                    <div  :class="item.isread=='yes'?'noticeRow2':'noticeRow'"  v-html="item.content"   @click="open_notice_detail(item.content,item._id,index,item.isread)"></div>

                    <div style="float:right">{{timestampToTime(item.timestamp/1000)}} </div>

                    <!-- <div :class='index%2==0? "list_detail":"list_detail2"' style='width:100%;' :data-guest_id='item.guest_id'   :data-ind='index'  :data-nickname="item.nickName"   bindtap='bindtodetail' >
                        <div class="detail_n"   :data-guest_id='item.guest_id'  style="width:35px">{{index+1}}</div>
                        <div class="detail_n"     :data-guest_id='item.guest_id'  style="width:70px;position:relative;">
                            <img :src="item.avatarUrl" alt="">
                        </div>

                        <div class="detail_n"     style="width:180px">{{item.nickName}}  </div>
                        <div class="detail_n"  :data-name="item.name"    style="width:120px">
                        <pre>{{ item.lasttime }}</pre>
                        </div>
    
                        <div class="detail_n"  :data-name="item.name"  :data-id='item._id' style="width:70px"> 
                    
                            <el-button type="info" plain :data-_id="item._id"   :data-ind="index"  style="height:24px;line-height:0px;">操作</el-button>
                        </div>  
                        
                    </div> -->
                
                </div>  
                <!-- border:1px solid rgb(190, 216, 42); -->
                <!-- $store.state.noticeInfo.num  -->
                <div style="width:100% "  v-if="$store.state.noticeInfo.num>0">
                    <!-- <el-pagination
                        style="float:right;width:200px;margin-top:20px;margin-bottom:20px "
                        page-size='15'
                        small
                        layout="prev, pager, next"
                        :total="50"
                        @change="ChangeNoticePage"
                        
                        >
                    </el-pagination> -->
<!-- :current-page.sync="currentPage" -->
                    <el-pagination 
                        style="float:right;width:200px;margin-top:20px;margin-bottom:20px "
                        small
                        hide-on-single-page
                        @current-change="ChangeNoticePage"
                        
                        :page-size="15"
                        layout="prev, pager, next, jumper"
                        :total="$store.state.noticeInfo.num">
                    </el-pagination>

                </div>
            
            </div>

            <!-- <span> 消息中心 </span> -->
            <span slot="footer" class="dialog-footer">
                <el-button @click="ReadAllNotice" style="margin-right:20px">全部已读</el-button>

                <el-button @click="noticeDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="noticeDialogVisible = false">确 定</el-button>
            </span>
        </el-dialog>



 

    </div>


 
</template>

<script>
import Pages from '@/components/Pages.vue'

function isphone() {
	var sUserAgent = navigator.userAgent.toLowerCase();
	var bIsIpad = sUserAgent.match(/ipad/i) == "ipad";
	var bIsIphoneOs = sUserAgent.match(/iphone os/i) == "iphone os";
	var bIsMidp = sUserAgent.match(/midp/i) == "midp";
	var bIsUc7 = sUserAgent.match(/rv:1.2.3.4/i) == "rv:1.2.3.4";
	var bIsUc = sUserAgent.match(/ucweb/i) == "ucweb";
	var bIsAndroid = sUserAgent.match(/android/i) == "android";
	var bIsCE = sUserAgent.match(/windows ce/i) == "windows ce";
	var bIsWM = sUserAgent.match(/windows mobile/i) == "windows mobile";
	if (bIsIpad || bIsIphoneOs || bIsMidp || bIsUc7 || bIsUc || bIsAndroid
			|| bIsCE || bIsWM) {
		return true
	} else {
		return false
	}
}

var filters = {
    toFix: function (value) {
        return value.toFixed(2)//此处2为保留两位小数
    }
}  
    let id = 1000;


    const routes = [
        { path:'/work/workbench', component: ()=>import('@/components/oa/workbench.vue'), name:"oa_workbench" , redirect:'/work' },
        

    ]
    const router = new VueRouter({
        routes,
        mode:'history',
        //   base:'/' 
    })
 

	export default {
 
        name: 'workbench',
        // metaInfo () {
        //     return {
        //         title: '诉讼费计算器'
        //     }
        // },
        // props: {
		// 	isPhone: Boolean
        // },
        components: { 
            Pages,
 
        },
        router,
		// placeholder:"hi",
        data() {
           
			return { 
                activeIndex:'1',
                screenWidth:window.innerWidth,
                screenHeight:window.innerHeight,
                subwindow:{},
                apply:[],
                flow:[],

                rootUrl:'https://api.oalaw.cn/',

                flow_icon:'el-icon-refresh', //el-icon-loading
                apply_icon:'el-icon-refresh', //el-icon-loading
                caseHandle:[
                    {"name":"客户登记","path":"/pages/process/newclient/newclient" , "tag":'client' ,"id":"1001" ,img:require("@/assets/images/oa/shenpi1.png" ) },
                    {"name":"收案审批","path":"/pages/process/newcase/newcase" , "tag":'shouanshenpi',"id":"1002" ,img:require("@/assets/images/oa/shenpi1.png")},
                    {"name":"开票申请","path":"/pages/process/invoice/invoice","tag":'shouanshenpi',"id":"1004" ,img:require("@/assets/images/oa/shenpi1.png")},
                    {"name":"用印申请","path":"/pages/process/seal/seal","tag":'shouanshenpi',"id":"1003" ,img:require("@/assets/images/oa/shenpi1.png")},
                    {"name":"退款申请","path":"/pages/process/refund/refund","tag":'shouanshenpi',"id":"1005" ,img:require("@/assets/images/oa/shenpi1.png")},
                    // {"name":"结案归档","path":"/pages/process/close/close","tag":'shouanshenpi',"id":"5" ,img:require("@/assets/images/oa/file1.png")},
                    // {"name":"利冲检索","path":"/pages/process/conflict/conflict","tag":'shouanshenpi',"id":"6" ,img:require("@/assets/images/oa/shenpi1.png")}
                ],
                msgDialogVisible:false,
                noticeDialogVisible:false,
                msgData:[],
            
             



                // dialogTableVisible: false,
                dialogFormVisible: false,
                form: {
                    name: '',
                    gender:'',
                    region: '',
                    date1: '',
                    date2: '',
                    delivery: false,
                    type: [],
                    resource: '',
                    desc: '',
                    depart:'',
                },
                formLabelWidth: '80px',
                mode:'new',
                mycase:[],

                tempsig:false,
                selectOnShow_index:'',
                namelist: ["Alabama", "Alaska", "Arizona",
                "Arkansas", "California", "Colorado",
                "Connecticut", "Delaware", "Florida",
                "Georgia", "Hawaii", "Idaho", "Illinois",
                "Indiana", "Iowa", "Kansas", "Kentucky",
                "Louisiana", "Maine", "Maryland",
                "Massachusetts", "Michigan", "Minnesota",
                "Mississippi", "Missouri", "Montana",
                "Nebraska", "Nevada", "New Hampshire",
                "New Jersey", "New Mexico", "New York",
                "North Carolina", "North Dakota", "Ohio",
                "Oklahoma", "Oregon", "Pennsylvania",
                "Rhode Island", "South Carolina",
                "South Dakota", "Tennessee", "Texas",
                "Utah", "Vermont", "Virginia",
                "Washington", "West Virginia", "Wisconsin",
                "Wyoming"],
                options: [],
                selectValue:'',
                value: [],
                list: [],
                loading: false,

                apply_page:1,
                task_num:0,
                notice_num:0,
                notice:[],
                self_notice:[],
                days30:2592000000,
                days7:604800000,
                timestamp:0,
     
            }

        },
                // computed: {

        //     listenstage () {
        //         console.log(this.$store.state.examine_sig)
        //         return this.$store.state.examine_sig
        //         // return  JSON.parse(JSON.stringify(this.$store.state.examine_sig))

        //     }

        // },
        watch:{
            
            // listenstage:function (newVal, oldVal) {
            //     console.log('oldVal.closed:',oldVal.closed)
            //     console.log('newVal.closed:',newVal.closed) 
            //     if(this.$store.state.examine_sig.num){
            //         console.log('333333333333333333')
            //         //业务处理
            //     }
            // },
            'subwindow.closed': {
                handler(oldVal,newVal){
                    console.log('oldVal.closed:',oldVal)
                    console.log('newVal.closed:',newVal) 
                }
            },

         
            
            deep: true,
            // immediate:true,



             

        },
        created(){
            // window.addEventListener('setItemEvent', function (e) {
            //     if (e.key === 'examine_sig') {   // tableData 是需要监听的键名
            //         console.log(JSON.parse(e.newValue))   // 这里的newValue就是localStorage中，键名为tableData对应的变化后的值。
            //     }
            // })
          
        },
        mounted(){
            //    console.log("this.$store.state.islogin:",this.$store.state.islogin)
            // window.console.log(this.data)
            this.timestamp= Date.parse(new Date())
            // this.list = this.namelist.map(item => {
            //     return { value: `value:${item}`, label: `${item}` };
            // });
            // window.console.log(this.list)


            this.GetTaskNotice()
            this.GetSelfNotice()
            this.GetFlow()
            this.getNotice()


            var task_refresh_num=this.$store.state.examine_sig
            let t= new Date().getTime();
            let sig=localStorage.getItem('examine_sig' )||0
            setInterval( ()=>{
                // console.log('this.$store.state.examine_sig:',localStorage.getItem('examine_sig' ))
    
                if(localStorage.getItem('examine_sig' ) != sig ){
                    // console.log('refresh ========================')
                    sig=localStorage.getItem('examine_sig' )
                    this.GetTaskNotice()
                }


            },3000 )

          
 
           
        },
 
        methods:{
            
           append(data) {
                const newChild = { id: id++, label: '未命名部门', children: [] };
                if (!data.children) {
                this.$set(data, 'children', []);
                }
                data.children.push(newChild);
            },

            remove(node, data) {
                const parent = node.parent;
                const children = parent.data.children || parent.data;
                const index = children.findIndex(d => d.id === data.id);
                children.splice(index, 1);
               
            },
            // modifyName(node, data){
            //     const parent = node.parent;
            //     const children = parent.data.children || parent.data;
            //     const index = children.findIndex(d => d.id === data.id);
              
            // },

            renderContent(h, { node, data, store }) {
                return (
                <span class="custom-tree-node">
                    <span>{node.label}</span>
                    <span>
                    <el-button size="mini" type="text" on-click={ () => this.append(data) }>增加子节点</el-button>
                    <el-button size="mini" type="text" on-click={ () => this.remove(node, data) }>删除该节点</el-button>
                    </span>
                </span>);



            },

            submit(){
                window.console.log('this.data:',this.data)
            },




            SearchStaff(node, data) {
                this.$prompt('请输入人员姓名', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                inputPattern: /\S+/,
                inputErrorMessage: '首个字符不能为空格'
                }).then(({ value }) => {
                    this.$message({
                        type: 'success',
                        message: '部门名称修改为: ' + value
                    });
                    const parent = node.parent;
                    const children = parent.data.children || parent.data;
                    const index = children.findIndex(d => d.id === data.id);
                    window.console.log("children:",children)
                    window.console.log("index:",index)
                    window.console.log("node:",node)
                    children[index].label=value

                    window.console.log("this.data:",this.data)

              

                }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '取消输入'
                });       
                });
            },


            timestampToTime(timestamp) {
                var date = new Date(timestamp * 1000);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
                var Y = date.getFullYear() + '-';
                var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
                var D = date.getDate() + '';
                var h = date.getHours() + ':';   //
                var m = date.getMinutes() + ':';//
                var s = date.getSeconds();//
                if (M.length==1){
                    M='0' +M
                }
                if (D.length==1){
                    D='0' +D
                }
                return Y + M + D +'    '+ h + m + s
            },


            showSelect(index){
                // this.inputVisible = true;
                window.console.log('showSelect event')
                // this.procedure[index].selectVisible=true;
                this.tempsig=true
                this.selectOnShow_index=index

                window.console.log('this.procedure ：',this.procedure)
            },

            handleSelectConfirm() {
                window.console.log('handleSelectConfirm event ,this.selectValue:',this.selectValue)
                // let selectValue = this.selectValue;
                // if (selectValue) {
                //     this.procedure[index].staff.push(selectValue);
                // }
                // this.tempsig = false;
                // this.selectValue = '';
            },

            remoteMethod(query) {
                if (query !== '') {
                this.loading = true;
                setTimeout(() => {
                    this.loading = false;
                    this.options = this.list.filter(item => {
                    return item.label.toLowerCase()
                        .indexOf(query.toLowerCase()) > -1;
                    });
                }, 200);
                } else {
                this.options = [];
                }
            },

            GetSelfNotice(page=1){
                var that=this
                var data= { 
                    whattodo: "GetSelfNotice",
                    page:page
                }
                this.axios.post(this.rootUrl+'oa',data
                ).then(function (res) {
                    // window.console.log(res)
                    if(res.status==200){
                        var result=res.data
                        // console.log('result:',result)
                        if(result.status=='ok'){
                            // let data=result.data
                            that.self_notice=result.data
                         
                            // let sig=0
                            // for (let p of apply){
                            //     for (let t of p.staff){
                            //         if (t.phone==that.$root.accountInfo.phone && t.onshow==1){
                            //             apply.mystatus=t.status
                            //             sig=1
                            //             break
                            //         }
                            //     }
                            //     if (sig==1){
                            //         break
                            //     }
                            // }
                            // that.apply=apply
              
                            // if ( page==1&&result.count.length>0){
                            //     that.task_num=result.count[0].totalCount
                            // }

                        }

            
        
                    }
                
                
                    
                }).catch(function (error) {
                    window.console.log(error);
                
                });
            },

            Refresh_myWork(){
                this.apply_icon='el-icon-loading'
                this.GetTaskNotice()
            },

            GetTaskNotice(page=1){

                var that=this
                var data= { 
                    whattodo: "GetTaskNotice",
                    page:page,
                    
                }
                
                this.axios.post(this.rootUrl+'oa',data
                ).then(function (res) {
                    // window.console.log(res)
                    if(res.status==200){
                        let result=res.data
                        // console.log('result:',result)
                        if(result.status=='ok'){
                            let apply=result.data
                            // that.apply=result.data
                            let sig=0
                            for (let p of apply){
                                for (let t of p.staff){
                                    if (t.phone==that.$root.userInfo.phone && t.onshow==1){
                                        apply.mystatus=t.status
                                        sig=1
                                        break
                                    }
                                }
                                if (sig==1){
                                    break
                                }
                            }
                            that.apply=apply
                            // that.apply_pages=apply.length
                            if ( page==1&&result.count.length>0){
                                that.task_num=result.count[0].totalCount
                            }

                        }

            
        
                    }
                
                    that.apply_icon='el-icon-refresh'
                    
                }).catch(function (error) {
                    window.console.log(error);
                    that.apply_icon='el-icon-refresh'
                });



            },

            ChagenApplyPage(page){
                this.apply_page=page
            },


            Refresh_Flow(){
                this.flow_icon='el-icon-loading'
                this.GetFlow()
            },

            GetFlow(){
                var that=this
                var data= { 
                    whattodo: "following_task",
                    page:1
                }
                
                this.axios.post(this.rootUrl+'oa',data
                ).then(function (res) {
                    // window.console.log(res)
                    if(res.status==200){
                        let result=res.data
                        // console.log('result:',result)
                        if(result.status=='ok'){
                            that.flow=result.data
                            var mycase=[]
                            for (let p of result.data){
                                if(p.template_id=='1002'){
                                    mycase.push(p)
                                }
                            }
                            // console.log("=============== mycase:",mycase)
                            that.mycase=mycase

                        }

            
        
                    }
                
                    that.flow_icon='el-icon-refresh'
                    
                }).catch(function (error) {
                    window.console.log(error);
                    that.flow_icon='el-icon-refresh'
                });


            },

            CheckThisFlow(obj,index){
                console.log('obj:',obj)
                if(obj.status!=2){
                    let routeData = this.$router.resolve({name:"form", params: {mode:'check' ,template_id:obj.template_id ,  id: obj._id} });
                    window.open(routeData.href, '_blank'); 
                }else{
                    let routeData = this.$router.resolve({name:"form", params: {mode:'rewrite' ,template_id:obj.template_id ,  id: obj._id} });
                    window.open(routeData.href, '_blank');
                }

                this.flow[index].isread=1
                // let routeData = this.$router.resolve({name:'1001', params: {mode:'examine' ,id: _id} });
                

            },

            Turn2Detail(e){
                var _id=e.srcElement.dataset._id
                var template_id=e.srcElement.dataset.template_id
                // var ind=e.srcElement.dataset.ind
                var mystatus=e.srcElement.dataset.mystatus
                console.log('template_id:',template_id,'_id:',_id)
                var mode='examine';
                // if(mystatus!=0){
                //     mode='check'
                // }else{
                //     mode='examine'
                // }
                // let routeData = this.$router.resolve({name:template_id, params: {mode:mode ,id: _id} });
                let routeData = this.$router.resolve({name:"form", params: {mode:'examine' ,template_id:template_id ,  id: _id} });
                 
                // { path:'/form/:template_id/:mode/:id', component: ()=>import('@/components/process/sheet.vue'), name:"form" }, 

                // window.console.log('routeData.href:',routeData.href)
                // let routeData = this.$router.resolve({name:template_id, query: {id:_id ,mode:mode }  });
                    // :to="{ name: 'article', query: {docid: item._id } }"
                this.subwindow=window.open(routeData.href, '_blank');
                // window.open(routeData.href, '_blank'); 
                // this.$router.push({name:template_id, params: {mode:mode ,id: _id} })






            },

            ChangeNoticePage(val){
                console.log('val:',val)
                this.getNotice(val)
            },

            ReadAllNotice(){
                var that=this
                var datas= { 
                    // _id: _id,
                    whattodo:'notice_allread',
                }
                this.axios.post(this.rootUrl+'oa',datas
                ).then(function (res) {
                    // window.console.log(res)
                    if(res.status==200){
                        var result=res.data
            
                    if (result.status=='ok'){
                        that.$store.commit('SubtractAllNotice')
                        let notice=that.notice
                        for(let p of notice){
                            p.isread='yes'
                        }
                        that.notice=notice
                    
                    } 
                    

                    }


                    
                }).catch(function (error) {
                    window.console.log(error);

                });
            },



             
            
            getNotice(page=1){
                var that=this
                var data= { 
                    whattodo: "GetNotice_oa",
                    page:page
                }
                
                this.axios.post(this.rootUrl+'oa',data
                ).then(function (res) {
                    // window.console.log(res)
                    if(res.status==200){
                        let result=res.data
                        // console.log('result:',result)
                        if(result.status=='ok'){
                            that.notice=result.data
                           
                            let noticeInfo={}
                            if ( page==1&&result.count.length>0){
                                that.notice_num=result.count[0].totalCount
                                let newnum=0
                                
                                for(let p of that.notice){
                                    p.content=p.content.replace(/<[\w\W]+?>/gmi,'')
                                    if(p.isread=='no'){
                                        newnum++

                                    }
                                }

                                
                                 
                                noticeInfo.num=result.count[0].totalCount
                                noticeInfo.newnum=newnum
                                
                                noticeInfo.data=result.data
                                that.$store.commit('SetNoticeInfo',noticeInfo)


                            }
                             


                        }

            
        
                    }
                
                
                    
                }).catch(function (error) {
                    window.console.log(error);
                
                });

            },

            open_notice_detail(detail,_id,index ,isread='no' ){
                // console.log("isread:",isread)
                this.notice[index].isread='yes'
                if (isread=='no'){
                    this.ReadThisNotice(_id)
                }
                 
                detail=detail.replace(/<[\w\W]+?>/g,'')
                this.$alert(detail, '通知', {
                    confirmButtonText: '确定',
                    callback: action => {
                        // this.$message({
                        // 	type: 'info',
                        // 	message: `action: ${ action }`
                        // });
                    }
                });




            },
            ReadThisNotice(_id){
                var that=this
                var datas= { 
                    _id: _id,
                    whattodo:'notice_oneread',
                }
                this.axios.post(this.rootUrl+'oa',datas
                ).then(function (res) {
                    window.console.log(res)
                    if(res.status==200){
                        var result=res.data
            
                    if (result.status=='ok'){
                        that.$store.commit('SubtractOneNotice')
                    
                    } 
                    

                    }


                    
                }).catch(function (error) {
                    window.console.log(error);

                });
            },
 



            Check_More_Info(){
                this.$router.push({name: 'info'  })                                                   
                 


            },


            NewForm(template_id){

                // let url='http://localhost:8080/#/form/'+template_id+'/new/0'
             
                let url='/#/form/'+template_id+'/new/0'
                window.open(url, '新建表单', 'height='+window.innerHeight+', width='+window.innerWidth+', top=0, left=0, toolbar=no, menubar=no, scrollbars=no, resizable=yes, location=no, status=no')
           
            },


            openNoticePanel(){
                console.log('openNoticePanel')
                // this.$emit('ChangePanelVisible','notice'); 
                this.MoreNotice()

            },

            MoreNotice(){
                this.ChangePanel('notice')

            },


            ChangePanel(data){ 
                var that=this
                window.console.log('ChangePanel data:',data)
                // if(!this.$root.userInfo.userId){
                // 	that.$message({
                // 		message: '请先登录哦',
                // 		type: 'warning'
                // 	});
                // 	return
                // }
                if (data=='msg'){
                    this.msgDialogVisible=true
                    this.msgPage=1
                    var datas= { 
                        whattodo: 'getList',
                        userId: '365919148', // this.$root.userInfo.userId,
                        page:1,
                    }
                    this.axios.post(this.rootUrl+'msg',datas
                    ).then(function (res) {
                        window.console.log(res)
                        // let respond = res.data
                        // that.saving_sig=0
                        if(res.status==200){
                            let result=res.data
                            if(result.status=='badgate'){
                                that.$message({
                                    message: '请先登录哦',
                                    type: 'warning'
                                });
                            }else if (result.status=='ok'){
                                let list = result.data
                                let len = list.length
                                if(len<15){
                                    that.msgPageLimit = true
                                }
                                else{
                                    that.msgPageLimit = false
                                }
                                // console.log('len:',len,'that.data.pageLimit:',that.data.pageLimit)
                                // let arr
                                let newMsg = 0;
                                for (let i = 0; i < len; i++) {
                                    let opo_userId
                                    if (list[i].members.length == 2) {
                                    if (that.$root.userInfo.userId == list[i].members[0]) {
                                        opo_userId = list[i].members[1]
                                    } else {
                                        opo_userId = list[i].members[0]
                                    }

                                    }
                                    list[i]['guest_id'] = opo_userId
                                    list[i]['nickName'] = list[i][opo_userId]['nickName']
                                    list[i]['lasttime'] = timestampToTime(list[i]['updateTime'])
                                    list[i]['avatarUrl'] = list[i][opo_userId]['avatarUrl']

                                    // newMsg = list[i][that.$root.userInfo.userId]['unread'] + newMsg //365919148
                                    newMsg = list[i]['365919148']['unread'] + newMsg //365919148


                                }
                                that.$root.notice.newMsg = newMsg
                                // console.log('ok')
                                that.msgData=list
                                window.console.log('msgData:',that.msgData)
                                // that.setData({
                                // 	data: list,
                                // 	userId: app.globalData.userId
                                // })
                                

                            } else if (result.status=='fail'){
                                that.$message('删除失败');
                                
                            }


                            
                        }

                        
                    }).catch(function (error) {
                        window.console.log(error);
                        // that.saving_sig=0
                    });






                }
                else if(data=='notice'){
                    this.noticeDialogVisible=true

                    this.getNotice()


    




                }else if(data=='mine'){
                    this.$router.push({path:'/mine'})
                }else if(data=='deposit'){
                    this.$router.push({path:'/deposit'})
                }
            },

        


        }
    
	}
</script>



<style  scoped>
 .text {
    font-size: 14px;
  }


  .msgCenter{
	/* min-width:400px;
	min-height: 600px; */

	width:100%;
    height:360px;
	overflow-y: scroll;
	display: flex;
	flex-direction: column;
  }


  .item_follow {
    font-size: 15px;

    width:100%;
     
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    padding: 12px 0;
    /* border:1px solid rgb(31, 90, 179); */
    cursor: pointer;
    overflow: hidden;

    margin-bottom: 10px;
  }


  .item_follow2{
        font-size: 15px;
        
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        padding: 12px 0;
        /* border:1px solid rgb(211, 13, 151); */
        cursor: pointer;

        color:#b9b9b9;

  }

  
    .noticeRow{
        flex-shrink: 0;
        min-height: 50px;
        font-size:18px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        white-space: normal;
        word-wrap: break-word;
        text-overflow:ellipsis;
        word-break:break-all;

        flex-direction: row;
    	flex-wrap: wrap;

    }

    .noticeRow2{
        flex-shrink: 0;
        min-height: 50px;
        font-size:18px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        white-space: normal;
        word-wrap: break-word;
        text-overflow:ellipsis;
        word-break:break-all;
        color:#b9b9b9;

        flex-direction: row;
    	flex-wrap: wrap;
    }

  
   /* .item_follow .left{
       width:100%;
       border:1px solid rgb(29, 202, 44);
   } */

    /* .item_follow .right{
        width:40%;
        border:1px solid rgb(199, 231, 19);

        display: flex;
        flex-direction: row;
        justify-content: flex-end;
    } */
    
  .box-card {
    width: 480px;
  }

  /* .clearfix{
    width:100%;
    border:1px solid rgb(199, 231, 19);
    height: 100%;

  } */
    .clearfix{
        justify-content: space-between;
    }

  .bench_wrap{
    display: flex;
    flex-direction: row;
    
    width:100%;

    /* border:1px solid rgb(199, 231, 19); */
  }
  .bench_wrap .left{
    width: 42%;
    display: flex;
    flex-direction: column;
    margin-left:auto;
    margin-right:auto;

    justify-content: flex-start;

     
    /* overflow: hidden; */

  }


.bench_wrap .mid{
    width: 27%;
    display: flex;
    flex-direction: column;
    margin-left:auto;
    margin-right:auto;

    justify-content: flex-start;
    /* border:1px solid rgb(191, 192, 185); */
     

  }

 .bench_wrap .mid .up,.down{
    height: 50%;

   
        
  }

   .bench_wrap .mid  .up{
    margin-bottom:0;
    /* border:1px solid rgb(191, 192, 185); */

    
  }

  
 .bench_wrap .mid  .down{
    margin-top:15px;
    /* border:1px solid rgb(191, 192, 185); */
  }


  .bench_wrap .right{
    width: 27%;
    display: flex;
    flex-direction: column;
    margin-left:auto;
    margin-right:auto;

    justify-content: flex-start;
 
    /* border:1px solid rgb(191, 192, 185); */

  }

  .mywork{
    display: flex;
    flex-direction: column;
    min-height: 80px;
    max-height: 160px;

    border-bottom:1px solid rgb(191, 192, 185); 
    padding-bottom:5px;
    margin-bottom:10px;
    cursor: pointer;

  }
  .mywork .up{
    width: 100%;
    min-height: 40px;
    font-size:16px;
    /* height: ; */
  }

  .mywork .down{
    display: flex;
    flex-direction: row;
    height: 40px;
    justify-content: flex-end;
    align-items: center;
    
  }

.page_box{
    width:100%;
    height: 70px;
    margin-bottom: 20px;
    /* border:1px solid rgb(191, 192, 185); */
    /* display: flex;
    flex-direction: row; */
    /* align-items: center; */
    line-height:70px;
    /* margin-right: 10px; */
}



.often_use{
  width:100%;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  /* border: 1rpx solid #aaa9a9; */
  /* margin-left: 2%; */
  /* margin-left: 8%; */
  /* margin-left: auto;
  margin-right: auto; */

  flex-wrap: wrap;
}
/* 
.toolbox{
  height: 120px;
  display: flex;
  flex-direction: column;
  
  width:22.5%;
  margin-left:1.5%;


  margin-top:20px;
  margin-bottom: 20px;
  cursor: pointer;


}


.toolbox .up{
  height: 80px;

  display: flex;
  width: 100%;

}

.toolbox .up  img{
  width:auto;

  height: 85%;

  margin: auto;
   
}

.toolbox .down{
  height: 18%;
   width: 100%;
  margin-top: 1.5%;

  font-size:14px;
  text-align: center;
} */


/* class="right_part" style="width:50%;display:flex;flex-direction:row;justify-content:flex-end" */
.right_part{
    width:50%;
    display:flex;
    flex-direction:row;
    justify-content: space-between;

}

.funbar{
    width: 100px;
    border: 1px solid #aaa9a9;
    height: 100%;


}

.fun_row_bar{
    height: 40px;
    /* border: 1px solid #aaa9a9; */
    width:99%;
    margin-bottom: 5px;
    margin-left: auto;
    margin-right: auto;

    box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);

    background-color: #FFF;
    border-radius: 5px;

}

 
</style>

<style  >
.el-submenu .el-submenu__title {
    height: 60px; 
    line-height: 40px!important;
    border-bottom: 2px solid transparent;
    color: #909399;
}

</style>
